import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styles from './PhoneInput.module.css';
import { DefaultPhoneIcon } from './DefaultPhoneIcon';
export var CountryIcon = function (_a) {
    var countryCode = _a.countryCode, _b = _a.selectedCountryFlag, selectedCountryFlag = _b === void 0 ? '' : _b, onClick = _a.onClick;
    return (_jsx(_Fragment, { children: countryCode ? (_jsx("img", { src: selectedCountryFlag, alt: "Country flag", className: styles.input__flag, onClick: onClick })) : (_jsx(DefaultPhoneIcon, { onClick: onClick })) }));
};
